import { NofshonUploadsComponent } from './nofshon-chul-uploads/nofshon-chul-uploads.component';
import { TashlumimComponent } from './tashlumim/nofshonim-chul-tashlumim.component';
import { NgModule } from '@angular/core';
import {NofeshChulDetailsComponent} from './nofshon-chul-details/nofshon-chul-details.component';
import { NofshonimChulRouting } from './nofshonim-chul.routes';
import { nofshonimChulHomeComponent } from './home/nofshonim-chul-home.component';
import { SharedModule } from '../shared/shared.module';
import { OrderNofeshChulComponent } from './order/order-nofshon-chul.component';
import { PirteyNofshimComponent } from './pirtey-nofshim/pirtey-nofshim.component';
import { NirshamimChulComponent } from './nirshamim/nirshamim.component';
import { MyDatePickerModule } from 'mydatepicker';
import { PirteyTashlumComponent } from './pirtey-tashlum/pirtey-tashlum.component';
import { NofeshService } from './../nofesh/nofesh.service';
import { NofshonimService } from './nofshonim.service';
import { NofshonChulEndRishumComponent } from './nofshon-chul-end-rishum/end-rishum.component';
import { TeurTashlumPipe } from './../shared/pipes/custom-teur-tashlum.pipe'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NofeshUploadsComponent } from '../nofesh/nofesh-uploads/nofesh-uploads.component';
// import { ModalComponent } from '../shared/modal/modal.component';

@NgModule({
    imports: [NofshonimChulRouting, SharedModule, MyDatePickerModule,FormsModule, ReactiveFormsModule 
        
    ],
    declarations: [
        //ModalComponent,
        NofeshChulDetailsComponent, 
        nofshonimChulHomeComponent, 
        OrderNofeshChulComponent, 
        PirteyNofshimComponent, 
        NirshamimChulComponent, 
        PirteyTashlumComponent, 
        TashlumimComponent,
        NofshonChulEndRishumComponent,
        TeurTashlumPipe, 
        NofshonUploadsComponent//,
        //UploadComponent,
    ], 
    providers: [
        NofeshService,
        NofshonimService
    ]
})

export class NofshonimChulModule { }